import { Col, Form, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../common/Button.tsx'
import DefaultDatePicker from '../../../common/datepicker/DefaultDatePicker.jsx'
import { IconAddNew } from '../../../common/icons'
import { PersonSelectMulti } from '../../../common/personselectmulti'
import Switch from '../../../common/Switch'
import { localDate } from '../../../common/utils'

export function AddTask({
	show,
	setShow,
	state,
	setDiscussion,
	discussionPerson,
	discussionPersonName,
	setState,
	hideAddButton = false,
}) {
	const { t } = useTranslation()
	const prefix = 'taskModal'

	const handleSave = () => {
		setDiscussion((currentDiscussion) => {
			if (state.id) {
				const tasks = currentDiscussion.tasks.map((task) => {
					if (task.id !== state.id)
						return task // keep existing
					else return state // overwrite task
				})
				return { ...currentDiscussion, tasks } // save edited task(s)
			}
			const newState = { ...state }
			newState.id = Math.random() // generate temporary id to allow edits before saving discussion
			return { ...currentDiscussion, tasks: [...currentDiscussion.tasks, newState] } // add a new task
		})
		setShow(false)
	}

	const handleClose = () => setShow(false)

	const openNewTaskModal = () => {
		setState({
			status: 'OPEN',
			created: localDate(),
			assignees: discussionPerson ? [{ personId: discussionPerson, personName: discussionPersonName }] : [],
		})
		setShow(true)
	}

	const handleChange = ({ target }) => {
		const value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value

		setState((currentTask) => {
			return {
				...currentTask,
				[target.id]: value,
			}
		})
	}

	const selectAssignees = (newValue) =>
		setState((data) => ({
			...data,
			assignees: newValue.map((person) => ({
				personId: person.value,
				personName: person.label.replace(/[0-9.]/g, ''),
			})),
		}))

	const isEdit = Boolean(state?.id)

	const modalTitle = isEdit ? t('EditTask', 'Muokkaa tehtävää/tavoitetta') : t('AddTask', 'Lisää tehtävä/tavoite')

	return (
		<>
			{!hideAddButton && (
				<Button className="addbutton mb-3" onClick={openNewTaskModal}>
					<IconAddNew /> {t('AddTask', 'Lisää tehtävä/tavoite')}
				</Button>
			)}
			{show && (
				<Modal show onHide={handleClose} backdrop="static" size="lg" fullscreen="lg-down" scrollable centered>
					<Modal.Header closeButton>
						<Modal.Title>{modalTitle}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row className="mb-1">
							<Form.Group as={Col} xl={4} className="position-relative" controlId="status">
								<Form.Label>{t('TaskStatus', 'Tehtävän/tavoitteen tila')}</Form.Label>
								<Form.Select value={state?.status ?? ''} onChange={handleChange}>
									<option value="OPEN">{t('Open', 'Avoinna')}</option>
									<option value="DONE">{t('Done', 'Tehty')}</option>
									<option value="LATE">{t('Late', 'Myöhässä')}</option>
								</Form.Select>
							</Form.Group>

							<Form.Group as={Col} xl={4} controlId="created">
								<DefaultDatePicker
									id={`${prefix}-created`}
									name="created"
									label={t('CreationDate', 'Luontipäivämäärä')}
									value={state?.created ?? ''}
									onChange={(iso) => handleChange({ target: { id: 'created', value: iso ?? '' } })}
								/>
							</Form.Group>
						</Row>

						<Row className="mb-1">
							<Form.Group as={Col} xl={12} controlId="title">
								<Form.Label>{t('Title', 'Otsikko')}</Form.Label>
								<Form.Control value={state?.title ?? ''} onChange={handleChange} />
							</Form.Group>
						</Row>

						<Row className="mb-1">
							<Form.Group as={Col} xl={12} controlId="description">
								<Form.Label>{t('Description', 'Kuvaus')}</Form.Label>
								<Form.Control as="textarea" rows="5" value={state?.description ?? ''} onChange={handleChange} />
							</Form.Group>
						</Row>

						<Row className="mb-1">
							<Form.Group as={Col} xl={4} controlId="dueDate">
								<DefaultDatePicker
									id={`${prefix}-dueDate`}
									name="dueDate"
									label={t('DueDate', 'Eräpäivä')}
									value={state?.dueDate ?? ''}
									onChange={(iso) => handleChange({ target: { id: 'dueDate', value: iso ?? '' } })}
								/>
							</Form.Group>

							<Form.Group as={Col} xl={4} style={{ marginTop: '32px' }} controlId="taskReminder">
								<Switch
									className="mb-1"
									id="taskReminder"
									label={t('ShowOnDashboard', 'Nostetaan etusivulle')}
									checked={state?.taskReminder ?? false}
									onChange={handleChange}
								/>
							</Form.Group>

							<Form.Group as={Col} xl={4} controlId="taskReminderDays">
								<Form.Label>{t('NotifyBeforeEnd', 'Ennen voimassaolon umpeutumista')}</Form.Label>
								<Form.Control value={state?.taskReminderDays ?? ''} onChange={handleChange} />
							</Form.Group>
						</Row>

						<Row className="mb-1">
							<Form.Group as={Col} xl={10} controlId="assignees">
								<Form.Label>{t('Assignees', 'Tekijät')}</Form.Label>
								<PersonSelectMulti
									selectedPersons={state.assignees}
									excludedIds={[]}
									selectChange={selectAssignees}
									noLabel
								/>
							</Form.Group>
						</Row>
					</Modal.Body>
					<Modal.Footer style={{ justifyContent: 'space-between' }}>
						<Button variant="cancel" onClick={handleClose}>
							{t('Cancel', 'Keskeytä')}
						</Button>
						<Button variant="primary" onClick={handleSave}>
							{t('Save', 'Tallenna')}
						</Button>
					</Modal.Footer>
				</Modal>
			)}
		</>
	)
}
